export const environment = {
  production: false,
  basePath: '',
  aiApiUrl: '/ai-api',
  aiProxyUrl: '/ai-proxy'
};
